import { randomIdentifier } from '@texas/utils/helpers/commonHelpers';
import { SearchQuery, EntityItem } from '../../../types';
import { conceptsApi } from '@texas/api/endpoints/conceptsApi';
import { ChatMessageEntityLinkType } from '@texas/api/endpoints/chat/chatApi';

export async function searchConcept(query: SearchQuery): Promise<EntityItem[]> {
  // Filter concepts based on the query, customer filters can be applied
  const response = await conceptsApi.filterConcepts({
    query: query.query,
    filters: query.filters,
  });

  if (response.hasError) {
    return [];
  }

  return response.data.map((c) => ({
    id: c.id,
    name: c.name,
    tag: c.tag,
    type: ChatMessageEntityLinkType.Concept,
    identifier: randomIdentifier(),
  }));
}
